import { ObjectToolbar as ObjectToolbarBlock } from 'src/blocks/object-toolbar';

import { type ObjectToolbarConfig, useObjectToolbar } from './useObjectToolbar';

export interface ObjectToolbarProps {
  /** Declarative toolbar config — resolved through {@link useObjectToolbar}. */
  config: ObjectToolbarConfig;
}

/**
 * Object-level toolbar, connected. Resolves the declarative `config` through
 * {@link useObjectToolbar} (permissions, form state, save/cancel wiring) and
 * renders the presentational `ObjectToolbar` block. This is the component pages
 * mount; the block stays a pure, prop-driven presentational layer underneath.
 */
export const ObjectToolbar = ({ config }: ObjectToolbarProps) => {
  // `loading` from useObjectToolbar is intentionally not forwarded: actions
  // already fail closed while permissions resolve, and the presentational block
  // has no skeleton/disabled API for it yet (reserved for Phase 1). Don't wire
  // it in until that API exists — see useObjectToolbar's JSDoc.
  const { props } = useObjectToolbar(config);

  return <ObjectToolbarBlock {...props} />;
};
